__turbopack_context__.v({
  "footer_bottom": "Footer-module-scss-module__RxnAoq__footer_bottom",
  "footer_bottom_center": "Footer-module-scss-module__RxnAoq__footer_bottom_center",
  "footer_bottom_left": "Footer-module-scss-module__RxnAoq__footer_bottom_left",
  "footer_bottom_right": "Footer-module-scss-module__RxnAoq__footer_bottom_right",
  "footer_column": "Footer-module-scss-module__RxnAoq__footer_column",
  "footer_p": "Footer-module-scss-module__RxnAoq__footer_p",
  "footer_sec": "Footer-module-scss-module__RxnAoq__footer_sec",
  "footer_social": "Footer-module-scss-module__RxnAoq__footer_social",
  "footer_social_links": "Footer-module-scss-module__RxnAoq__footer_social_links",
  "footer_upper": "Footer-module-scss-module__RxnAoq__footer_upper",
  "icon": "Footer-module-scss-module__RxnAoq__icon",
});
